import {
  SylController,
  SylApi,
} from '@syl-editor/core-utilities';
import React from 'react';
import ReactDOM from 'react-dom';
import LinkInput from './LinkInput';
import Message from '@/component/Message';

// const isUrlReg = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?/g;
/* eslint-disable max-len */
const Icon = (
  <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" />
  </svg>
);

export default class LinkController extends SylController<any> {
  public toolbar = {
    className: 'diyLink',
    tooltip: 'diyLink', // tip内容
    icon: Icon, // 按钮
    handler(editor: SylApi) {
      // 通过 编辑器实例.commnad.插件名.方法名 调用
      editor.command.diyLink.insert();
    },
  };

  // 外部调用时传入的参数可以从第二位开始取到
  public insertLink = (editor: SylApi) => {
    const { index, length } = editor.getSelection();
    this.editor.removeShadow('link-bg');

    // editor.command.toolbarInline.hide();
    editor.appendShadow({
      index,
      length,
      attrs: {
        id: 'link-bg',
        style: 'background: #aeaeae',
      },
      spec: {
        key: 'link-bg',
      },
    }, true);

    const linkBox = document.getElementById('link-bg');
    const rang = (linkBox as any).getBoundingClientRect();
    const oldVal = document.createElement('div');
    oldVal.id = 'syl_link_container';
    document.body.appendChild(oldVal);
    ReactDOM.render(<LinkInput
      x={rang.x - (322 - rang.width) / 2}
      y={rang.y + rang.height}
      onChange={(href) => {
        if (href) {
          this.editor.setFormat({
            diyLink: {
              href,
            },
          });
        } else {
          Message.info('请检查填写地址是否正确');
          return;
        }
        reset();
      }}
      onClose={() => {
        reset();
      }}
    />, oldVal);

    const reset = () => {
      this.editor.removeShadow('link-bg');
      this.editor.setSelection({ index: index + length, length: 0 });
      setTimeout(() => {
        oldVal.parentNode?.removeChild(oldVal);
      }, 0);
    };
  };

  public disable = (editor: SylApi) => {
    const { $from } = editor.view.state.selection;
    if ($from.parent.type.spec.code) return true;
    return false;
  };

  // 注册插件的command
  public command = {
    insert: this.insertLink,
  };
}
